import { NotificationSnackbar } from '@components/shared/Snackbar/NotificationSnackbar';
import { HyperDXErrorBoundary } from '@components/shared/ErrorBoundary/HyperDXErrorBoundary';
import { AppRoutes } from '@config/router/router';
import { theme } from '@config/theme';
import { useHeartbeat } from '@features/chat/hooks';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { APIProvider } from '@vis.gl/react-google-maps';
import 'react-international-phone/style.css';
import 'react-toastify/dist/ReactToastify.css';
import { SWRConfig } from 'swr';
import './i18n';

export const App = () => {
	useHeartbeat();

	return (
		<HyperDXErrorBoundary>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
					<ThemeProvider theme={theme}>
						<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID as string}>
							<SWRConfig
								value={{
									shouldRetryOnError: false,
								}}
							>
								<AppRoutes />
								<NotificationSnackbar />
							</SWRConfig>
						</GoogleOAuthProvider>
					</ThemeProvider>
				</APIProvider>
			</LocalizationProvider>
		</HyperDXErrorBoundary>
	);
};

export default App;
